import React, { useEffect, useState } from "react";
import { Link, Outlet, useLoaderData } from "react-router-dom";
import { getFieldsList } from "../../lib/api";
import { IAPIResponse, IField } from "../../types/api";
import { Table } from "react-bootstrap";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { alertActions } from "../../features/alert/alertSlice";

export const loader = async () => {
    return {
        fields: await getFieldsList(),
    };
};

const FieldsIndex = (): React.JSX.Element | undefined => {
    const {
        fields: { fields: loadedFields },
    } = useLoaderData() as {
        fields: IAPIResponse & { fields: IField[] };
    };

    const dispatch = useAppDispatch();
    const [fields, setFields] = useState<IField[]>(loadedFields);

    useEffect(() => {
        const updateFields = async () => {
            try {
                const { fields } = await getFieldsList();
                setFields(fields);
            } catch (error) {
                dispatch(
                    alertActions.error({
                        title: "The server encountered a problem fetching the fields list.",
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                );
            }
        };

        updateFields();
    }, [location.pathname]);

    const isOnFieldListPage = /fields\/?$/.test(location.pathname);

    return isOnFieldListPage ? (
        <div className="fieldListContent" data-testid="fieldListContent">
            <h2>Field List</h2>
            <Link
                to={`/league-management/fields/add`}
                className="btn btn-primary createButton"
            >
                Add New Field
            </Link>
            <Table striped borderless>
                <thead>
                    <tr>
                        <th>Field Name</th>
                        <th># Fields</th>
                        <th>Active</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {fields
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(f => (
                            <tr key={f.id}>
                                <td>{f.name}</td>
                                <td>{f.diamonds && f.diamonds.length}</td>
                                <td>{f.active ? "Active" : "Inactive"}</td>
                                <td>
                                    <Link to={`edit/${f.id}`}>edit</Link>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </div>
    ) : (
        <Outlet />
    );
};

export default FieldsIndex;
